
//
// Debug Controller
//
// Do debug or auto-testing tasks on component gallery or test pages.
//

module.exports = function DebugController ($page, $$) {


  //
  // Fake pin number service
  //

  var pinInput = getWidgetAtDom($$('[data-widget="pin-input"]'));

  document.addEventListener('keypress', function (event) {
    pinInput.inject(event.key);
  });

  pinInput.onPin(function (pin) {
    pinInput.busy(true);

    delay(1, function () {
      if (pin == '1234') {
        pinInput.accept();
      } else {
        pinInput.reject();
      }
    });
  });


  //
  // Turn debug styles on and off
  //

  $(document).on('keydown', whichKey(192, function (event) {
    var targetClass = event.shiftKey ? 'show-widgets' : 'debug';
    var $body       = $('body');
    var bodyViews   = $body.attr('data-view').split(' ');
    newViews = contains(bodyViews, targetClass) ? remove(bodyViews, targetClass) : bodyViews.concat(targetClass);
    $body.attr('data-view', newViews.join(' '));
  }));

}

